export default function SimpleSelect({ name, id, value, placeholder, input, children,  disabled =false }) {
    return (
        <select
            id={id}
            disabled={disabled}
            name={name}
            onChange={input.onChange}
            className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200"
            defaultValue={value ? value : input?.value}
        >
            {children}
        </select>
    );
}
